<div class="white_paper_wrap">
    <div class="paper_top_sections">
        <h1>학술 언어 분야로 특회된 트링카와 Grammarly &  LanguageTool 기능 비교</h1>
    </div>

    <div class="need_whitePaper_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="need_content_text">
                        <h2>이 보고서가 필요한 이유는?</h2>
                        <p>일반 영문에 대해서는 여러 문법 검사기가 있지만 학술적 영문, 용어, 과학적 스타일, 출판 준비에 특화된 것은 흔하지 않습니다.</p>

                        <p>이 보고서를 자세히 살펴보면 개인적, 전문적, 학술적, 기술적 글에 사용하기 위해 글쓰기 보조 & 문법 검사 & 언어 교정 툴을 평가하고 탑재하려 할 때 정확한 정보에 근거하여 결정할 수 있습니다. </p>

                        <p>이 보고서는 트링카가 왜 학술적 글쓰기에 가장 적합한지 정확히 언급하고 이미지 자료를 제공하며, 정확도와 활용 가능 범위, 독보적인 출판 준비 기능에 대해 균형 있게 설명합니다.</p>
                        <div class="download_whitePaper text-center">
                            <a id="downloadThisWhitePaper" href="../../../assets/resources/Trinka_WhitePaper.pdf" download="trinka-vs-grammarly-vs-language-tool">
                                <img src="../../../assets/images/whitePaper_download.png" alt="whitePaper_download">보고서 다운로드</a>
                        </div>
                        <div class="key_takewaye_sections">
                            <h2>주요 내용</h2>
                            <div class="row">
                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>1</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>전 세계 작가, 저자, 전문 학술 저자가 구체적으로 느끼는 불편 사항.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>2</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>현재 사용되는 글쓰기 보조 툴의 성능과 한계.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>3</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>트링카 vs. Grammarly vs. LanguageTool의 비교 와 차이점 </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>4</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>트링카는 다른 그 어떤 언어 교정 AI 툴 보다 성능이 뛰어납니다.  </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="sneak_peek_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="sneak_heading">
                        <h2>보고서 미리보기</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section class="whitePaper_slider testimonials">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="center">

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="comparison_slide">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary_slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar_slide">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="comparison_slide">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary_slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar_slide">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="comparison_slide">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary_slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar_slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="comparison_slide">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary_slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar_slide">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="comparison_slide">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary_slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar_slide">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="comparison_slide">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary_slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar_slide">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="container">

            <div class="row">
                <div class="col-sm-12">
                    <div id="customers-testimonials" class="owl-carousel">
                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="../../../assets/images/whitePaperSlide_02.png" alt="">
                            </div>
                        </div>

                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="../../../assets/images/WhitePaperSlider_01.png" alt="">
                            </div>
                        </div>
                        
                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="../../../assets/images/WhitePaperSlider_03.png" alt="">
                            </div>
                        </div>
                        
                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="../../../assets/images/whitePaperSlide_02.png" alt="">
                            </div>
                        </div>

                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="../../../assets/images/WhitePaperSlider_01.png" alt="">
                            </div>
                        </div>
                        
                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="../../../assets/images/WhitePaperSlider_03.png" alt="">
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div> -->
    </section>

    <!-- <div class="whtiePaper_sections">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <div class="WhitePaper_cards slicer_changes">
                        <div class="overlay_whitepaper"></div>
                        <img src="../../../assets/images/WhitePaperSlider_01.png" alt="">
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="WhitePaper_cards">
                        <img src="../../../assets/images/whitePaperSlide_02.png" alt="">
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="WhitePaper_cards slicer_changes">
                        <div class="overlay_whitepaper"></div>
                        <img src="../../../assets/images/WhitePaperSlider_03.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="bottomSilderButtons">
        <div class="download_whitePaper text-center">
            <a id="downloadThisWhitePaperFooter" href="../../../assets/resources/Trinka_WhitePaper.pdf" download="trinka-vs-grammarly-vs-language-tool">
                <img src="../../../assets/images/whitePaper_download.png" alt="download">
                보고서 다운로드</a>
        </div>
    </div>
</div>